module.exports = __webpack_public_path__ + "img/icon_07.cb1d72b0.svg";